const i18n = {
  translations:  window.$apTranslations || {},
  registerTrans(translations = {}) {
    i18n.translations = translations
  },
  getVal(obj, keyPath = '') {
    const pathArr = keyPath.split('.')
    if (pathArr.length > 0) {
      return pathArr.reduce((targetObj, key) => {
        return targetObj[key]
      }, obj)
    }
  },
  tr(key, ...args) {
    let oldValue;
    let { translations } = i18n;

    if (key.includes("@@")) {
      oldValue = key.slice(0, key.indexOf("@@"));
      key = key.slice(key.indexOf("@@") + 2);
    }

    let value = i18n.getVal(translations, key) || oldValue || key;

    if (args.length > 0) {
      value = value.format(args);
    }
    return value;
  },
  trans(str) {
    str = str.replace(
      /\{([^\{\}]*?)@{1,2}(\w*)(,.+?)?\}/g,
      function (m0, m1, m2, m3) {
        return i18n._trans_by_matches(m1, m2, m3);
      }
    );

    str = str.replace(
      />\s*([^<>]*?)@@(\w*)(,.+?)?\s*</g,
      function (m0, m1, m2, m3) {
        return ">" + i18n._trans_by_matches(m1, m2, m3) + "<";
      }
    );

    return str;
  },
  _trans_by_matches(m1, m2, m3) {
    let value = m1;
    let key = m2;
    let args = m3 || "";
    let v = String(i18n.tr(value + "@@" + key));

    if (args) {
      args = args.slice(1).split(",");

      for (let i = 0; i < args.length; i++) {
        let arg = args[i].trim();
        if (arg.startsWith("@")) {
          arg = String(i18n.tr(arg.slice(1)));
        }

        args[i] = arg;
      }

      v = v.format(args);

      for (let i = 0; i < args.length; i++) {
        let arg = args[i].trim();
        if (!v.includes(arg)) {
          v += "_" + arg;
        }
      }
    }

    return v;
  },
}

export default i18n